/*==========================================================
    STICKY HEADER / TUCK & SHOW
==========================================================*/

var lastScrollTop = 0;  // determines last scrolled position
var deltaDown = 0; // determines when the nav shrinks, when scrolling down
var deltaUp = 0; // determines when the nav unshrinks, when scrolling up

$(window).scroll(function(event) {
    // Detect scroll position
    var st = $(this).scrollTop();

    if (st == lastScrollTop ) {
        return;

    // If user has scrolled down
    } else if (st > lastScrollTop && lastScrollTop >= 0) {
        $("html").removeClass("scrollingUp");

        // Ready to shrink nav if user scrolled down far enough
        if (st > deltaDown){
            $("html").addClass("scrollingDownward").addClass("scrolling");

            // Shrink header
            if (Modernizr.mq("only screen and (min-width: 992px)")){
                var shift = (parseInt($("header").css('padding-top')) + $("#topBar").outerHeight(true)) * -1;
                var mainNavHeight = $("#mainNav").height();

                //Reposition header and shrink logo container
                $("header").css("transform", "translateY(" + shift + "px)");
                // $("#logo").css("max-height", mainNavHeight + "px");
            }
        }

    // If user has scrolled up
    } else {
        $("html").removeClass("scrollingDownward").addClass("scrollingUp").addClass("scrolling");

        // Reposition header to original location and unshrink logo container
        if (Modernizr.mq("only screen and (min-width: 992px)")){
            $("header").css("transform", "translateY(0)");
        }
    }

    lastScrollTop = st;

    // If user has hit the top of page
    if (st <= deltaUp) {
        $("html").removeClass("scrolling").addClass("hitTop").removeClass("scrollingUp");
        //console.log("hit top of page");
    } else {
        $("html").removeClass("hitTop");
    }
});